import React from 'react'
import cx from 'classnames'
import Link from 'components/Link'

import './styles.sass'

export const Tabs = ({ children }) => (
  <div className="tab-bar">
    {children}
  </div>
)

export const TabItemLink = ({ children, active, ...props }) => (
  <Link {...props} className={cx('tab-item', { 'is-active': active })} activeClassName={'is-active'}>
    {children}
  </Link>
)



// WEBPACK FOOTER //
// ./src/client/components/Tabs/index.jsx